import { engineComponent } from "neo-common";
import { BaseController } from "./BaseController";
import { Paylines } from "../Paylines";
import { PaylinesSelector } from "../PaylinesSelector";
import { Symbols } from "../Symbols";
import { WinAnimator } from "../WinAnimator";
import { Machine } from "../Machine";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { WinAnimator2 } from "../../CustomComponents/WinAnimator2";
import { MaskElement } from "../../CustomComponents/MaskElement";
import { GameManager } from "../../Managers/GameManager";
import { AppContext } from "../../../Common/AppContext";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../Utils/FrameTimer";
import { PlayList } from "../../Components/Sounds/PlayList";
import { ImageElement } from "../../Components/Elements/Graphics/ImageElement";
import { ITweenable, Tweens } from "../../Components/Effects/Tweens";
import { SwitchStyleCaseAttributes } from "../../Components/Elements/Styles/SwitchStyle";
import { TeasingBonus } from "../../CustomComponents/TeasingBonus";
import Container = PIXI.Container;
import { DataManager } from "../../Managers/DataManager";
import { LayoutManager } from "../../Managers/LayoutManager";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { ModuleManager } from "../../Managers/ModuleManager";

@engineComponent(ComponentTypes.DisplayObject)
export class BaseView extends LayoutContainerElement {
    public static LayoutManager: LayoutManager;

    private _controller: BaseController;
    private _wasFinished: boolean = false;
    private _outroDelay: FrameTimerEventEmitter;

    private _paylines: Paylines;
    private _paylinesSelector: PaylinesSelector;

    private _symbols: Symbols;
    private _machine: Machine;
    private _noWinContainer: ContainerElement;
    private _winAnimator: WinAnimator2;

    private _paylinesBottomContainer: ContainerElement;
    private _reels: ContainerElement;
    private _reelsCoordsX: Array<number>;
    private _fires: SwitchElement;
    private _multipliers: SwitchElement;
    private _winFlowWin: ContainerElement;
    private _bg: SwitchElement;
    private _logoReflection: SwitchElement;
    private _glass: ImageElement;
    private _frame: ContainerElement;
    private _lights: ContainerElement;
    private _symbolLight: ContainerElement;
    private _flares: ContainerElement;
    private _innerShadow: ContainerElement;
    private _odlesk: ContainerElement;

    private _teasingBonus: TeasingBonus;
    private _teasing: ContainerElement;

    private minSpinRotation: number;

    constructor() {
        super();

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this._teasingBonus = new TeasingBonus();
        this.minSpinRotation = 0;
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        BaseView.LayoutManager = new LayoutManager();

        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                }

                if (this.childs[key] instanceof PaylinesSelector) {
                    this._paylinesSelector = this.childs[key];
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof Machine) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimator) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "NoWinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._noWinContainer = this.childs[key];
                }

                if (key === "PaylinesBottomContainer" && this.childs[key] instanceof ContainerElement) {
                    this._paylinesBottomContainer = this.childs[key];
                }

                if (key === "Fires" && this.childs[key] instanceof SwitchElement) {
                    this._fires = this.childs[key];
                }

                if (key === "LogoReflection" && this.childs[key] instanceof SwitchElement) {
                    this._logoReflection = this.childs[key];
                }

                if (key === "Reels" && this.childs[key] instanceof ContainerElement) {
                    this._reels = this.childs[key];
                    this._reels.cacheAsBitmap = false;
                    this._reelsCoordsX = [];
                    for (let i = 0; i < this.childs[key].children.length; i++) {
                        if (this.childs[key].children[i].name != "ReelBG") {
                            this._reelsCoordsX.push(this.childs[key].children[i].position.x);
                        }
                    }
                }

                if (key === "Multipliers" && this.childs[key] instanceof SwitchElement) {
                    this._multipliers = this.childs[key];
                }

                if (key === "Glass" && this.childs[key] instanceof ImageElement) {
                    this._glass = this.childs[key];
                }

                if (key === "Frame" && this.childs[key] instanceof ContainerElement) {
                    this._frame = this.childs[key];
                }

                if (key === "InnerShadow" && this.childs[key] instanceof ContainerElement) {
                    this._innerShadow = this.childs[key];
                }

                if (key === "Odlesk" && this.childs[key] instanceof ContainerElement) {
                    this._odlesk = this.childs[key];
                }

                if (key === "Lights" && this.childs[key] instanceof ContainerElement) {
                    this._lights = this.childs[key];
                }
                if (key === "SymbolLight" && this.childs[key] instanceof ContainerElement) {
                    this._symbolLight = this.childs[key];
                }

                if (key === "Flares" && this.childs[key] instanceof ContainerElement) {
                    this._flares = this.childs[key];
                }

                if (key === "Teasing" && this.childs[key] instanceof ContainerElement) {
                    this._teasingBonus = this.childs[key];
                }

                if (key === "WinFlowWin" && this.childs[key] instanceof ContainerElement) {
                    this._winFlowWin = this.childs[key];
                }

                if (key === "BG" && this.childs[key] instanceof SwitchElement) {
                    this._bg = this.childs[key];
                }
            }

            if (this._symbols == null) {
                if (DEBUG) {
                    this.log("ERROR no symbols");
                }
            }

            if (this._machine == null) {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }

            if (this._paylines == null) {
                if (DEBUG) {
                    this.log("WARNING no paylines");
                }
            } else {
                if (this._paylinesBottomContainer != null) {
                    this._paylines.setSpecialContainer(this._paylinesBottomContainer);
                }
            }

            if (this._winAnimator == null) {
                if (DEBUG) {
                    this.log("WARNING no winAnimator");
                }
            }
        }
    }

    initReceived(controller: BaseController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.baseResponse != null) {
                    if (GameManager.baseResponse.initData != null && GameManager.baseResponse.initData.reels != null) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.baseResponse.initData.reels,
                            this._teasingBonus,
                            this._bg,
                        );
                    }

                    if (
                        GameManager.baseResponse.screen != null &&
                        GameManager.baseResponse.screen.reels != null &&
                        GameManager.baseResponse.screen.reels.length !== 0
                    ) {
                        if (this._winAnimator != null) {
                            this._winAnimator.on(
                                WinAnimator.FinishWinCalculation,
                                this.finishWinCalculation.bind(this),
                            );
                            this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                            this._winAnimator.initialize(
                                this._symbols,
                                this._paylines,
                                this._noWinContainer,
                                null,
                                this._multipliers,
                                this._glass,
                                this._frame,
                                this._innerShadow,
                                this._odlesk,
                                this._teasingBonus,
                                this._reels,
                                this._winFlowWin,
                                this._bg,
                                this._lights,
                                this._flares,
                                this._symbolLight,
                                this._logoReflection,
                            );
                            this._winAnimator.showSymbols(GameManager.baseResponse.screen.reels);
                        }
                        this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);
                    } else {
                        if (DEBUG) {
                            this.log("ERROR no reels in response");
                        }
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no base reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.toggleElements(false);
        if (this._bg != null && ModuleManager.gambleActive()) {
            this._bg.goToCase("GAMBLE");
        }
    }

    disableLogo(): void {
        if (this.childs["Logo"] != null) {
            this.removeChild(this.childs["Logo"]);
        }
        if (this.childs["LogoReflection"] != null) {
            this.removeChild(this.childs["LogoReflection"]);
        }
    }

    toggleElements(visible: boolean): void {
        if (this._paylinesBottomContainer != null) {
            this._paylinesBottomContainer.visible = visible;
        }
        if (this._reels != null) {
            this._reels.visible = visible;
        }
        if (this._noWinContainer != null) {
            this._noWinContainer.visible = visible;
        }
        if (this._paylines != null) {
            this._paylines.visible = visible;
        }
        if (this._winAnimator != null) {
            this._winAnimator.visible = visible;
        }
    }

    initIntro(): void {
        if (GameManager.baseResponse.currentWin > 0) {
            PlayList.stop("SND_BaseLoop");
            PlayList.loop("SND_BaseRecaploop");
        } else {
            PlayList.stop("SND_BaseRecaploop");
            PlayList.loop("SND_BaseLoop");
        }
        this._winAnimator.showInitWins(GameManager.baseResponse.wins, GameManager.baseResponse.currentWin);
        this.toggleElements(true);
        if (GameManager.baseResponse.currentWin > 0) {
            for (let i = 0; i < this._reels.children.length; i++) {
                if (this._reels.children[i].name != "ReelBG") {
                    let item = <any>this._reels.children[i];
                    item.tint = 0x676144;
                }
            }

            if (GameManager.baseResponse.gameMultiplier == null || GameManager.baseResponse.gameMultiplier <= 1) {
                this._bg.goToCase("WIN");
            } else {
                this._bg.goToCase("ON");
            }
        }
    }

    collect(): void {
        PlayList.stop("SND_BaseRecaploop");
        PlayList.loop("SND_BaseLoop");
        if (this._fires != null) {
            this._fires.goToCase("WIN_NORMAL");
        }

        if (this._lights != null) {
            for (let i = 0; i < this._lights.children.length; i++) {
                let flare: SwitchElement = <any>this._lights.children[i];
                flare.goToCase("NORMAL");
            }
        }

        // this._bg.goToCase('TOOFF')

        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }
        this._winAnimator.reset(true);
    }

    spin(): void {
        PlayList.stop("SND_BaseRecaploop");
        PlayList.loop("SND_BaseLoop");
        PlayList.stop("SND_BaseX2");
        PlayList.stop("SND_BaseTeaser");
        PlayList.stop("SND_BaseTeaserStart");
        PlayList.stop("SND_BaseWinReel");

        if (this._winFlowWin != null) {
            for (let i = 0; i < this._winFlowWin.children.length; i++) {
                let winFlow: SwitchElement = <any>this._winFlowWin.children[i];
                winFlow.goToCase("NORMAL");
            }
        }

        if (GameManager.gameResponse.totalWin > 0 && this._fires != null) {
            this._fires.goToCase("WIN_NORMAL");
        }
        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }

        this.minSpinRotation = Math.floor(
            Math.random() * (this._machine._minSpinRotationLong - this._machine._minSpinRotation) +
                this._machine._minSpinRotation,
        );

        this._machine.spinStart(this._winAnimator.reset(false), this.minSpinRotation);
    }

    stop(): void {
        PlayList.stop("SND_BaseX2");
        PlayList.stop("SND_BaseWinReel");
        for (let i = 0; i < this._reels.children.length; i++) {
            if (this._reels.children[i].name != "ReelBG") {
                let item: ITweenable = <any>this._reels.children[i];
                Tweens.removeTweens(item, "position");
                Tweens.positionTween(item, {
                    tweenX: [item.position.x, this._reelsCoordsX[i - 1]],
                    tweenY: [item.position.y, item.position.y],
                    tweenDuration: 15,
                });
            }
        }

        this._machine.spinStop(null, true);
        this._machine.removeTeasing(this._teasingBonus);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);
        this._machine.spinReelsImages(this._reels, this.minSpinRotation);
        this._machine.spinStop(null, false, true);
    }

    onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.baseResponse.screen.reels, this._machine.actualReelStopped);
    }

    machineStopped(): void {
        this.machineStoppedDelayed();
        this._machine.removeTeasing(this._teasingBonus);
    }

    machineStoppedDelayed(): void {
        if (GameManager.baseResponse.currentWin > 0 && this._fires != null) {
            this._fires.goToCase("WIN");
        }
        this._wasFinished = false;
        this._controller.machineStopped();
        PlayList.stop("SND_BaseTeaser");
        PlayList.stop("SND_BaseTeaserStart");
        if (
            this._winAnimator.showWins(
                GameManager.baseResponse.wins,
                GameManager.baseResponse.currentWin,
                GameManager.baseResponse.gameMultiplier,
                this._reels,
            )
        ) {
            let currentAnimationIndex: number = this._winAnimator.getAnimationIndex();

            PlayList.stop("SND_BaseLoop");
            if (currentAnimationIndex == 3) {
                this._logoReflection.goToCase("WIN");
            }

            if (GameManager.baseResponse.gameMultiplier != null && GameManager.baseResponse.gameMultiplier === 3) {
                this.showWinFlow();
            } else {
                let winFlow: SwitchElement = <any>this._winFlowWin.children[1];
                winFlow.goToCase("INIT");
            }
        } else {
            if (this._winFlowWin != null) {
                for (let i = 0; i < this._winFlowWin.children.length; i++) {
                    let winFlow: SwitchElement = <any>this._winFlowWin.children[i];
                    winFlow.goToCase("NORMAL");
                }
            }
        }
    }

    showWinFlow(): void {
        for (let i = 0; i < GameManager.baseResponse.wins.length; i++) {
            let win = GameManager.baseResponse.wins[i];
            if (
                win.symbols[0] == win.symbols[1] &&
                win.symbols[0] == win.symbols[2] &&
                [2, 3, 4, 5].indexOf(win.symbols[0]) > -1
            ) {
                let winFlow: SwitchElement = <any>this._winFlowWin.children[win.symbols[0] - 2];
                winFlow.goToCase("INIT");
                break;
            }
        }
    }

    finishWinCalculation(): void {
        this._wasFinished = true;
        this._controller.winCalculationFinished();
    }

    finishWinAnimator(): void {
        if (!DataManager.Autoplay) {
            PlayList.stop("SND_BaseLoop");
            PlayList.loop("SND_BaseRecaploop");
        }

        this._logoReflection.goToCase("NORMAL");
        this._controller.allWinsFinished();

        if (this._winFlowWin != null) {
            for (let i = 0; i < this._winFlowWin.children.length; i++) {
                let winFlow: SwitchElement = <any>this._winFlowWin.children[i];
                winFlow.goToCase("NORMAL");
            }
        }
    }

    resetWinAnimator(): void {
        this._winAnimator.reset(true);
    }

    intro(): void {
        PlayList.loop("SND_BaseLoop");
        this.toggleElements(true);
        if (this._bg != null) {
            this._bg.goToCase("OFF");
        }
        if (this._fires != null) {
            this._fires.goToCase("NORMAL");
        }
    }

    outro(): void {
        PlayList.stop("SND_BaseLoop");
        PlayList.stop("SND_BaseX2");
        PlayList.stop("SND_BaseRecaploop");
        if (this._fires != null) {
            this._fires.goToCase("WIN_NORMAL");
        }
        if (this._winFlowWin != null) {
            for (let i = 0; i < this._winFlowWin.children.length; i++) {
                let winFlow: SwitchElement = <any>this._winFlowWin.children[i];
                winFlow.goToCase("NORMAL");
            }
        }
        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }

        let wasFinished: boolean = this._wasFinished;
        let inHighWins: boolean = this._winAnimator.reset(true);

        if (wasFinished) {
            this.outroFinished();
        } else {
            if (inHighWins) {
                this._outroDelay.start(60);
            } else {
                this._outroDelay.start(30);
            }
        }
    }

    outroFinished(): void {
        this.toggleElements(false);
        PlayList.stop("SND_BaseX2");
        if (this._bg != null) {
            this._bg.goToCase("GAMBLE");
        }
        this._controller.outroFinished();
    }

    selectPayline(): void {
        if (this._paylinesSelector != null) {
            this._paylinesSelector.select();
        }
    }

    disableBase(): void {
        this._winAnimator.resetTimer();
    }

    /**
     * Toggle all sounds used in base game (background, effects, .etc)
     * @param enable
     */
    toggleSounds(enable: boolean): void {
        if (enable) {
            PlayList.loop("SND_BaseLoop");
        } else {
            PlayList.stop("SND_BaseLoop");
            PlayList.stop("SND_BaseRecaploop");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Base/BaseView.ts
 **/